import { marked } from 'marked';

const renderer = new marked.Renderer();

const originalLinkRenderer = renderer.link.bind(renderer);
renderer.link = function( token ) {
  const html = originalLinkRenderer(token);
  return html.replace('<a ', '<a target="_blank" rel="noopener noreferrer" ');
};

marked.setOptions({
  renderer,
  gfm: true,
  breaks: false,
});

export function renderMarkdown(md) {
  if (!md) {
    return '';
  }

  return marked.parse(md);
}
